<template>
  <GChart
      type="BarChart"
      :data="chartData"
      :options="chartOptions"
  />
</template>

<script>
export default {
  name: "BarChart",
  data () {
    return {
      // Array will be automatically processed with visualization.arrayToDataTable function
      chartData: [],
      chartOptions: {
        bars: 'horizontal',
        hAxis: {
          format:'#',
          viewWindow: {
            min: 0,
            max: 15000,
          }
        },
        chartArea: {
          left: 0,
          width: '70%'
        },
        colors: ['#595958', '#f5a808', '#7570b3'],
        height: 100,
        width: '100%',
        backgroundColor: '#EDECEB',
      }
    }
  },
  props: ['label', 'kosten', 'emission', 'max'],
  methods: {
    updateChart() {
      let kosten = Number.parseInt(this.kosten)
      let emission =Number.parseInt(this.emission);
      this.chartData =  [
          ['Jahr', 'Kosten / €', 'CO2-Emission / kg'],
          ['', kosten , emission]
      ];
      this.chartOptions.hAxis.viewWindow.max = this.max
    }
  },
  watch: {
    kosten() {
      this.updateChart()
    },
    emission() {
      this.updateChart()
    },
    max() {
      this.updateChart()
    }
  },
  mounted() {
      this.updateChart();
  }
}

</script>

<style scoped>

</style>
